import Call from '../../Call.v2';
import {objToQs} from '../../Utils';

const Affids = {
    get() {
        return Call(`propellerAds/affids`);
    },
};

export default Affids;



// WEBPACK FOOTER //
// ./src/services/API/components/PropellerAds/Affids.js